import { getConsent, onConsentChange } from './cookies-consent.js';

const EVENT_PREFIX = 'gw_blog_';
const PROD_HOST = 'blog.gtowizard.com';
const isProduction = window.location.hostname === PROD_HOST;
let gtagLoaded = false;
let cachedDimensions = null;

function hydratePostContextFromDataset() {
  if (!window.GhostConfig) window.GhostConfig = {};
  const ds = document.body?.dataset || {};
  window.GhostConfig.post = {
    id: ds.postId || '',
    slug: ds.postSlug || '',
    title: ds.postTitle || '',
    primaryTag: ds.postPrimaryTag || '',
    primaryTagName: ds.postPrimaryTagName || '',
    author: ds.postAuthor || '',
    tier: ds.postTier || '',
    publishedAt: ds.postPublishedAt || '',
    readingTime: ds.postReadingTime || ''
  };
}

hydratePostContextFromDataset();

function loadGtag() {
  const gaId = window.GhostConfig?.googleAnalyticsId;
  if (!gaId || gtagLoaded) return;

  gtagLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());

  window.gtag('config', gaId, {
    send_page_view: true,
    transport_url: isProduction ? 'https://xyz.gtowizard.com' : undefined,
    custom_map: {
      dimension1: 'post_type',
      dimension2: 'post_format',
      dimension3: 'post_primary_tag',
      dimension4: 'post_author',
      dimension5: 'post_tier'
    },
    ...getPostDimensions()
  });
}

function parseTagList(raw) {
  return (raw || '')
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);
}

function matchTagList(primaryTag, list) {
  if (!primaryTag) return null;
  const lower = primaryTag.toLowerCase();
  const match = list.find(item => lower.includes(item.toLowerCase()));
  return match ? match.toLowerCase() : null;
}

function classifyPostType(post, bodyClass, types) {
  if (!post?.primaryTag) {
    if (bodyClass.includes('tag-template')) return 'tag';
    if (bodyClass.includes('author-template')) return 'author';
    if (bodyClass.includes('home-template')) return 'home';
    return 'other';
  }
  const match = matchTagList(post.primaryTag, types);
  if (match) return match;
  if (bodyClass.includes('tag-patch-notes') || post.primaryTag === 'patch-notes') return 'patch-note';
  return 'article';
}

function classifyPostFormat(post, bodyClass, formats) {
  if (!post?.primaryTag) return 'none';
  const match = matchTagList(post.primaryTag, formats);
  if (match) return match;
  if (bodyClass.includes('tag-video')) return 'video';
  return 'article';
}

function computeDimensions() {
  const cfg = window.GhostConfig || {};
  const post = cfg.post || {};
  const bodyClass = document.body?.className || '';
  const types = parseTagList(cfg.articlesTypes);
  const formats = parseTagList(cfg.articlesFormats);

  return {
    post_type: classifyPostType(post, bodyClass, types),
    post_format: classifyPostFormat(post, bodyClass, formats),
    post_primary_tag: post.primaryTag || '',
    post_author: post.author || '',
    post_tier: post.tier || 'none'
  };
}

export function getPostDimensions() {
  if (!cachedDimensions) cachedDimensions = computeDimensions();
  return cachedDimensions;
}

export function sendBlogEvent(eventName, params = {}) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', `${EVENT_PREFIX}${eventName}`, { ...getPostDimensions(), ...params });
}

export function initAnalytics() {
  const gaId = window.GhostConfig?.googleAnalyticsId;
  if (!gaId) return;

  const consent = getConsent();
  if (consent?.analytics) {
    loadGtag();
  }

  onConsentChange((newConsent) => {
    if (newConsent.analytics) {
      loadGtag();
    }
  });
}
